module.exports = __webpack_public_path__ + "static/media/gif1.f07ec0e3.gif";